export const installRouterGuards = ({ router, store }) => {
  const allowedPages = new Set([
    'setNewPasswordPage',
    'terms-of-participation',
    'challenge-terms-of-participation',
    'termsPage',
    'logout',
    'organizationPageRegisterStartupLegacy',
    'organizationPageRegisterStartup',
  ])
  const allowedPaths = new Set(['/privacy-policy'])

  router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title || 'vestbee'
    const user = await store.dispatch('user/getUser')

    const isPageAllowedWithoutNewPassword = (toRoute) => {
      if (allowedPages.has(toRoute.name) || allowedPaths.has(toRoute.path)) {
        return true
      } else {
        return false
      }
    }

    if (
      user &&
      user.require_to_set_password &&
      !isPageAllowedWithoutNewPassword(to)
    ) {
      next({ name: 'setNewPasswordPage', replace: true })
    } else {
      next()
    }
  })
}

export default {
  installRouterGuards,
}
